import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup.object({
  serial_number: yup
    .string()
    .required('Serial # is required')
    .trim()
    .min(1, 'Serial # must be at least 1 character'),
  label: yup
    .string()
    .required('Label is required')
    .trim()
    .min(1, 'Label must be at least 1 character'),
})

const resAddDevice = yupResolver(schema)

export default resAddDevice
